import { createSelector } from 'reselect'
import { moduleName } from './constants'

const stateSelector = (state) => state[moduleName]

export const menuOpenedSelector = createSelector(stateSelector, (state) => state.menuOpened)
